import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { usuariosAPI } from '../services/api';
import { useSesion } from '../context/SesionContext';
import './Cuenta.css';

function Cuenta() {
  const navigate = useNavigate();
  const { usuario, entrar, salir } = useSesion();
  const [modo, setModo] = useState('entrar');
  const [enviando, setEnviando] = useState(false);
  const [error, setError] = useState('');

  const [datos, setDatos] = useState({
    email: '',
    nombre: '',
    password: '',
    handicap: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDatos(prev => ({ ...prev, [name]: value }));
    setError('');
  };

  const cambiarModo = (nuevo) => {
    setModo(nuevo);
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setEnviando(true);

    try {
      const respuesta = modo === 'entrar'
        ? await usuariosAPI.login(datos.email.trim(), datos.password)
        : await usuariosAPI.registro({
            email: datos.email.trim(),
            nombre: datos.nombre.trim(),
            password: datos.password,
            handicap: datos.handicap === '' ? 0 : Number(datos.handicap)
          });

      entrar(respuesta.data.token, respuesta.data.usuario);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'No se pudo conectar con el servidor');
    } finally {
      setEnviando(false);
    }
  };

  if (usuario) {
    return (
      <div className="cuenta">
        <div className="header">
          <h1>Tu cuenta</h1>
          <p>{usuario.nombre}</p>
        </div>

        <div className="container">
          <div className="card fade-in">
            <div className="cuenta-dato">
              <span className="cuenta-etiqueta">Email</span>
              <span className="cuenta-valor">{usuario.email}</span>
            </div>
            <div className="cuenta-dato">
              <span className="cuenta-etiqueta">Handicap</span>
              <span className="cuenta-valor">{usuario.handicap}</span>
            </div>

            <button
              className="btn btn-primary btn-full"
              onClick={() => navigate('/mis-partidas')}
              style={{ marginTop: '20px' }}
            >
              📋 Mis partidas
            </button>

            <button
              className="btn btn-secondary btn-full"
              onClick={() => navigate('/')}
              style={{ marginTop: '12px' }}
            >
              Volver al inicio
            </button>

            <button
              className="btn btn-danger btn-full"
              onClick={() => { salir(); navigate('/'); }}
              style={{ marginTop: '12px' }}
            >
              Cerrar sesión
            </button>
          </div>
        </div>
      </div>
    );
  }

  const creandoCuenta = modo === 'crear';

  return (
    <div className="cuenta">
      <div className="header">
        <h1>{creandoCuenta ? 'Crear cuenta' : 'Entrar'}</h1>
        <p>Guarda tus partidas y tu handicap</p>
      </div>

      <div className="container">
        <div className="card fade-in">
          <div className="cuenta-pestanas">
            <button
              type="button"
              className={`cuenta-pestana ${!creandoCuenta ? 'activa' : ''}`}
              onClick={() => cambiarModo('entrar')}
            >
              Entrar
            </button>
            <button
              type="button"
              className={`cuenta-pestana ${creandoCuenta ? 'activa' : ''}`}
              onClick={() => cambiarModo('crear')}
            >
              Crear cuenta
            </button>
          </div>

          {error && <div className="error">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={datos.email}
                onChange={handleChange}
                placeholder="tu@email.com"
                required
                autoComplete="email"
              />
            </div>

            {creandoCuenta && (
              <>
                <div className="form-group">
                  <label htmlFor="nombre">Tu nombre</label>
                  <input
                    type="text"
                    id="nombre"
                    name="nombre"
                    value={datos.nombre}
                    onChange={handleChange}
                    placeholder="Ej: Juan Pérez"
                    required
                    maxLength="50"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="handicap">Tu handicap</label>
                  <input
                    type="number"
                    id="handicap"
                    name="handicap"
                    value={datos.handicap}
                    onChange={handleChange}
                    placeholder="Ej: 18.5"
                    min="0"
                    max="54"
                    step="0.1"
                  />
                </div>
              </>
            )}

            <div className="form-group">
              <label htmlFor="password">Contraseña</label>
              <input
                type="password"
                id="password"
                name="password"
                value={datos.password}
                onChange={handleChange}
                placeholder={creandoCuenta ? 'Mínimo 8 caracteres' : '••••••••'}
                required
                autoComplete={creandoCuenta ? 'new-password' : 'current-password'}
              />
              {creandoCuenta && (
                <small className="cuenta-aviso">
                  No hay recuperación por email: si la olvidas, tendrá que
                  restablecerla el administrador.
                </small>
              )}
            </div>

            <button type="submit" className="btn btn-primary btn-full" disabled={enviando}>
              {enviando ? 'Un momento...' : creandoCuenta ? 'Crear cuenta' : 'Entrar'}
            </button>

            <button
              type="button"
              className="btn btn-secondary btn-full"
              onClick={() => navigate('/')}
              style={{ marginTop: '12px' }}
            >
              Volver
            </button>
          </form>
        </div>

        <div className="cuenta-nota">
          <div className="info-icon">ℹ️</div>
          <p>
            Registrarse es opcional. Puedes jugar sin cuenta, pero entonces las
            partidas no quedan guardadas a tu nombre.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Cuenta;
